import * as React from 'react'
import { FC, useCallback, useMemo } from 'react'
import { styles } from './styling'
import { currencyString } from '@sales-center/common'
import { useNavigate } from 'react-router-dom'
import { ClosedWonQueueSubmissionsDashboardDTO } from '@user/store/dashboard/widgets/closedWonQueueSubmissions/typings'
import { soldServiceStatusText } from '@user/components/SoldServices/utils/soldServiceStatusText'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

interface Props {
  data: ClosedWonQueueSubmissionsDashboardDTO
}

export const SoldServiceListCard: FC<Props> = (props) => {
  const {
    data: {
      closedDate,
      opportunityId,
      opportunityName,
      primaryContactName,
      servicesCount,
      soldServiceStatus,
      totalValue,
    },
  } = props

  const { formatDate } = useLocalizationDateFormat()

  const closedDateFormatted = useMemo(
    () => (closedDate ? formatDate(closedDate, 'date') : ''),
    [closedDate, formatDate],
  )

  const statusDisplay = useMemo(
    () => soldServiceStatusText(soldServiceStatus),
    [soldServiceStatus],
  )

  const totalValueFormatted = useMemo(
    () => `$${currencyString(totalValue)}`,
    [totalValue],
  )

  const navigate = useNavigate()
  const handleOppNameClick = useCallback(() => {
    navigate(`/opportunities/${opportunityId}`)
  }, [navigate, opportunityId])

  return (
    <Box sx={styles.tarjeta}>
      <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box sx={styles.name}>
            <Button
              sx={styles.textButton}
              data-test-id="closed-won-queue-submissions-widget-opportunity-name-button"
              variant="text"
              onClick={handleOppNameClick}
            >
              {primaryContactName} - {opportunityName}
            </Button>
          </Box>
          <Box sx={styles.status}>{statusDisplay}</Box>
        </Box>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box sx={styles.count}>Services Count: {servicesCount}</Box>
        </Box>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box sx={styles.total}>{totalValueFormatted}</Box>
          <Box sx={styles.date}>Date Closed Won: {closedDateFormatted}</Box>
        </Box>
      </Box>
    </Box>
  )
}
SoldServiceListCard.displayName = 'SoldServiceListCard'
